import { render } from "./testdataexportview.vue?vue&type=template&id=ba1cd3a8"
import script from "./testdataexportview.vue?vue&type=script&lang=js"
export * from "./testdataexportview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__